import { getMapBy } from '@spendesk/general-type-helpers/Map';
import { isNotNullable } from '@spendesk/general-type-helpers/misc';

import { type ExportAsCsvColumn } from 'src/core/utils/exportAsCsv';

import type { CostCenterWithBudgets } from '../../costCenter';
import type { Member } from '../../member';

const getOwnerName = (member: Member) => {
  if (member.isPending) {
    return member.email;
  }
  return member.fullname;
};

export const getCostCenterExportColumns = (
  members: Member[],
): ExportAsCsvColumn<CostCenterWithBudgets>[] => {
  const memberById = getMapBy(members, 'id');

  return [
    {
      title: (translator) =>
        translator('multiEntityHub.costCenters.table.header.name'),
      value: (costCenter) => costCenter.name,
    },
    {
      title: (translator) =>
        translator('multiEntityHub.costCenters.table.header.type'),
      value: (costCenter, translator) =>
        costCenter.isMultiEntity
          ? translator('multiEntityHub.costCenters.table.type.cross-entity')
          : translator('multiEntityHub.costCenters.table.type.entity-specific'),
    },
    {
      title: (translator) => translator('costCenters.owner'),
      value: (costCenter) => {
        const owner = memberById.get(costCenter.ownerId);
        if (!owner) {
          return '';
        }
        return getOwnerName(owner);
      },
    },
    {
      title: (translator) => translator('costCenters.form.viewers'),
      value: (costCenter) => {
        const coOwners = costCenter.viewerIds
          .map((viewerId) => memberById.get(viewerId))
          .filter(isNotNullable);
        return coOwners.map((coOwner) => getOwnerName(coOwner)).join(', ');
      },
    },
  ];
};
